module.exports = __webpack_public_path__ + "static/media/hero.c4cff385.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/hero.png
// module id = 2921
// module chunks = 0